module.exports = __webpack_public_path__ + "img/upload-disabled.d5b705f5.svg";